import React from 'react'
import { Link } from 'react-router-dom'

export default function Introduction () {
    return (
        <div className= 'pt-10'>
        <div className="intro-container">
        <div className="intro-top">
        <div className="slide-in-left"></div>    
            <h1 className='md:text-7xl sm:text-6xl text-4xl font-bold md:py-6 leading-8'>Gregory Swan</h1>
            <h2 className='md:text-5xl sm:text-4xl text-2xl font-bold md:py-6'>iOS Software Engineer</h2>
            <h5 className='md:text-2xl sm:text-4xl text-1xl font-bold md:py-6'>Swift • SwiftUI • AVFoundation • StoreKit 2</h5>
        </div>
        <div className="intro">
         <p><img
            className="mx-auto w-48 md:w-56 h-auto rounded-lg"
            src="https://sunbizlocal.com/gs.jpg"
            alt="Gregory Swan"
          /> </p>  
         <h3 className='md:text-xl max-w-md mx-auto pb-5 pt-10'> I design, build, ship, and maintain native iOS applications from concept through App Store release.</h3>
         <div className='md:mx-auto'>
         <p className='md:text-xl max-w-md mx-auto pb-5'> My work includes real-time audio processing, device integrations, state-driven application architecture, in-app purchases, analytics, physical-device testing, and post-launch product development.</p>
        
         </div>

<div className="about-buttons">
  <Link to="/projects">
    <button className="project-button">Projects</button>
  </Link>

  <Link
    to="/greg-swan-resume.pdf"
    target="_blank"
    rel="noopener noreferrer"
  >
    <button className="project-button">Resume</button>
  </Link>
</div>
  
 
                  
            </div>        
         </div>
         </div> 
    )
}